import React from 'react';
import { Text, StyleSheet, Image, View } from '@react-pdf/renderer';

type Props = {
  fifthPageBarChart: string;
  hourlyHeatmap: string;
  fifthPageBandName: string;
};

const styles = StyleSheet.create({
  title: {
    fontFamily: 'Helvetica-Bold',
    fontSize: 14,
    color: '#4E73C3',
    marginBottom: 16,
  },
  paragraph: {
    color: '#000',
    lineHeight: 1.5,
    letterSpacing: -0.32,
  },
});

const FifthPage = ({
  fifthPageBarChart,
  hourlyHeatmap,
  fifthPageBandName,
}: Props) => {
  return (
    <View wrap={false}>
      <Text style={styles.title}>How has the air quality been overall? </Text>
      <View
        style={{
          display: 'flex',
          flexDirection: 'row',
          maxWidth: 499,
          width: 499,
          maxHeight: 160,
          height: 160,
          marginBottom: 32,
        }}
      >
        <View style={{ width: 188, marginRight: 16, fontSize: 11 }}>
          <Text style={{ ...styles.paragraph, marginBottom: 20 }}>
            Overall, Air Quality has been generally{' '}
            <Text style={{ fontFamily: 'Helvetica-Bold' }}>
              {fifthPageBandName}.
            </Text>
          </Text>
          <Text style={styles.paragraph}>
            Unlike daily air quality, which considers the worst hourly
            measurement as the daily value, this chart summarises all hourly
            measurements, including weekends and nights, as a percentage total
            of the month.
          </Text>
        </View>
        <View style={{ width: 295 }}>
          <Image style={{ width: 295 }} src={fifthPageBarChart} />
        </View>
      </View>
      <View>
        <Text style={styles.title}>
          Have there been any specific pollution events?
        </Text>
        <Text style={{ ...styles.paragraph, marginBottom: 16, fontSize: 11 }}>
          Certain pollution events, like rush-hour traffic, or fireworks night,
          can cause short-term spikes of poor air quality. This hourly heatmap
          will help you identify particular times in the day when air quality
          has been poor.
        </Text>
        <View style={{ width: 499, marginBottom: 10 }}>
          <Image style={{ width: 499, height: 410 }} src={hourlyHeatmap} />
        </View>
      </View>
    </View>
  );
};

export default FifthPage;
